<script setup lang="ts">
    import { Task } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import EditTask from './EditTask.vue';

    interface Props {
        task: Task;
    }

    defineProps<Props>();
</script>

<template>
    <DataTableActions :data="task">
        <EditTask :task="task" />
    </DataTableActions>
</template>
